
import { useState } from 'react';

export default function ContactSection() {
  return (
    <section id="contact-section" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区域 */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            联系我们
          </h2>
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            多种联系方式，专业团队为您提供贴心服务
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* 联系信息 */}
          <div className="space-y-8">
            <div>
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#663333] mb-6 text-center">
                多种联系方式
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">电话咨询</h4>
                    <p className="text-xs sm:text-sm text-gray-600">400-888-6666</p>
                    <p className="text-xs text-gray-500">周一至周日 9:00-21:00</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-fill text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">微信咨询</h4>
                    <p className="text-xs sm:text-sm text-gray-600">shunnianchen888</p>
                    <p className="text-xs text-gray-500">扫码添加专属顾问</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-fill text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">邮箱咨询</h4>
                    <p className="text-xs sm:text-sm text-gray-600">service@shunnianchen.com</p>
                    <p className="text-xs text-gray-500">24小时内回复</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-fill text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">到店咨询</h4>
                    <p className="text-xs sm:text-sm text-gray-600">云南省昆明市官渡区茶城路88号</p>
                    <p className="text-xs text-gray-500">顺年陈体验中心</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 服务承诺 */}
            <div className="bg-gradient-to-r from-[#663333] to-[#775544] rounded-2xl p-6 lg:p-8 text-white max-w-2xl mx-auto">
              <h4 className="text-sm sm:text-base lg:text-xl font-bold mb-4 text-center">服务承诺</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#cc9966] text-lg"></i>
                  <span className="text-xs sm:text-sm">24小时内响应咨询</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#cc9966] text-lg"></i>
                  <span className="text-xs sm:text-sm">专业顾问一对一服务</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#cc9966] text-lg"></i>
                  <span className="text-xs sm:text-sm">全程免费基础咨询</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#cc9966] text-lg"></i>
                  <span className="text-xs sm:text-sm">客户信息严格保密</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}